package com.milta.core.localization.translations.nl

import com.milta.core.localization.ErrorStrings

internal val Errors = ErrorStrings(
    generic = "Er is een fout opgetreden",
    error = "Fout",
    fieldRequired = "Dit veld is verplicht",
    invalidEmail = "Ongeldig e-mailadres",
    fileTooLarge = "Bestand te groot. Kies een lichter bestand.",
)
